import { unwrapEnvelopeOr } from '@/model/client';
import { useGetApiProjectsByProjectIdQuery } from '@/model/project/api.generated';
import type { ProjectResponse } from '@/model/project/dto.generated';
import { skipToken } from '@reduxjs/toolkit/query/react';

export type ProjectByIdResult = {
  project: ProjectResponse | undefined;
  isPending: boolean;
  isError: boolean;
};

export function useProjectById(projectId: string | null | undefined): ProjectByIdResult {
  const { currentData, isError } = useGetApiProjectsByProjectIdQuery(
    projectId ? { projectId } : skipToken,
  );
  const project = unwrapEnvelopeOr<ProjectResponse | undefined>(currentData, undefined);

  return {
    project,
    isPending: Boolean(projectId) && project === undefined && !isError,
    isError,
  };
}
